// src/App.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Activation from "./pages/Activation";
import { Registration } from "./pages/Registration";
import { Payment } from "./pages/Payment";

const App: React.FC = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route
            path="/"
            element={<Activation />}
          />
          <Route
            path="/promocional"
            element={<Activation />}
          />
          <Route
            path="/black-friday"
            element={<Activation />}
          />
          <Route
            path="/aniversario"
            element={<Activation />}
          />
          <Route
            path="/cpfl"
            element={<Activation paymentType="cpfl" />}
          />
          <Route
            path="/boleto"
            element={<Activation paymentType="boleto" />}
          />
          <Route
            path="/pix-automatico"
            element={<Activation paymentType="pix_automatico" />}
          />
          <Route
            path="/registro"
            element={<Registration />}
          />
          <Route
            path="/pagamento"
            element={<Payment />}
          />
          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace
              />
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
